import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Packages from "../components/Packages";
import Inclusions from "../components/Inclusions";
import Places from "../components/Places";
import Fleet from "../components/Fleet";
import Testimonials from "../components/Testimonials";
import BookingForm from "../components/BookingForm";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import { Toaster } from "../components/ui/toaster";

const Home = () => {
  return (
    <div className="bg-[#fffaf3]">
      <Navbar />
      <Hero />
      <About />
      <Packages />
      <Inclusions />
      <Places />
      <Fleet />
      <Testimonials />
      <BookingForm />
      <Footer />
      <FloatingButtons />
      <Toaster />
    </div>
  );
};

export default Home;
